type StatusMessageProps = {
   id: string
   status: { message: string; isError: boolean }
}

/**
 * Renders a form status line coloured by outcome (muted when empty, red on error,
 * green on success).
 *
 * @param props - The element id and the status.
 * @returns The status element.
 */
const StatusMessage = (props: StatusMessageProps) => (
   <p
      id={props.id}
      class="text-xs"
      classList={{
         'text-ink-muted': !props.status.message,
         'text-red-400': props.status.isError,
         'text-emerald-400': Boolean(props.status.message) && !props.status.isError,
      }}
   >
      {props.status.message}
   </p>
)

export default StatusMessage
